

export function clearState() {
	return {
		type: 'CLEAR_STATE'
	}
}